// PolitykaPrywatnosci
import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <section className="py-12 bg-[#edece8] min-h-screen">
      <div className="max-w-4xl mx-auto px-4">
        <button 
          onClick={() => navigate(-1)}
          className="mb-6 text-yellow-600 hover:text-yellow-700 flex items-center transition-colors"
        >
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Powrót
        </button>
        
        <div className="bg-white rounded-lg shadow-lg p-6 md:p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">
            Polityka Prywatności
          </h1>
          
          <div className="text-gray-700 space-y-8">
            <div className="border-b pb-4">
              <p className="text-sm text-gray-500 mb-2">
                Data ostatniej aktualizacji: {new Date().toLocaleDateString('pl-PL')}
              </p>
              <p className="italic">
                Niniejsza Polityka Prywatności informuje o zasadach przetwarzania danych osobowych
                w związku z korzystaniem z usług wynajmu krótkoterminowego.
              </p>
            </div>

            <section>
              <h2 className="text-xl font-semibold mb-4 text-gray-800">
                I. Administrator danych osobowych
              </h2>
              <div className="bg-gray-50 p-4 rounded-md">
                <p>
                  <strong>Wynajem Domków Urszula Drużna</strong>
                  <br />
                  ul. Rydzowa 1
                  <br />
                  84-104 Jastrzębia Góra
                </p>
                <div className="mt-2 space-y-1">
                  <p>
                    <span className="font-medium">Telefon:</span> +48 608 025 978
                  </p>
                  <p>
                    <span className="font-medium">E-mail:</span> kontakt@kolorowedomki.com
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4 text-gray-800">
                II. Cel przetwarzania danych
              </h2>
              <p className="mb-3">
                Przetwarzamy Pani/Pana dane osobowe w następujących celach:
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Zawarcie i wykonanie umowy wynajmu krótkoterminowego</li>
                <li>Ustalenie, dochodzenie lub obrona przed roszczeniami</li>
                <li>Cele archiwizacyjne (dowodowe)</li>
                <li>Cele analityczne:
                  <ul className="list-circle pl-5 mt-1 space-y-1">
                    <li>Lepszy dobór usług do potrzeb naszych klientów</li>
                    <li>Ogólna optymalizacja naszych produktów</li>
                    <li>Optymalizacja procesów obsługi</li>
                    <li>Budowanie wiedzy o naszych klientach</li>
                  </ul>
                </li>
                <li>Marketing bezpośredni – oferowanie naszych produktów i usług</li>
                <li>Realizacja prawnie uzasadnionego interesu zabezpieczenia informacji na wypadek prawnej potrzeby wykazania faktów</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4 text-gray-800">
                III. Dobrowolność podania danych
              </h2>
              <div className="bg-yellow-50 p-4 rounded-md border border-yellow-200">
                <p>
                  Podanie danych osobowych jest <strong>dobrowolne, ale niezbędne</strong> do zawarcia
                  umowy o świadczenie usług wynajmu krótkoterminowego.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4 text-gray-800">
                IV. Odbiorcy danych
              </h2>
              <p className="mb-3">
                Odbiorcami Pani/Pana danych osobowych mogą być:
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Podmioty, którym mamy obowiązek przekazywania danych na gruncie obowiązujących przepisów prawa</li>
                <li>Podmioty świadczące na naszą rzecz usługi związane z rezerwacją pokoi</li>
                <li>Podmioty świadczące usługi prawnicze, informatyczne, transportowe</li>
                <li>Firmy dostarczające przesyłki kurierskie i pocztę</li>
                <li>Likwidatorzy szkód</li>
                <li>Wykonawcy usług w ramach likwidacji szkód</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4 text-gray-800">
                V. Okres przetwarzania danych
              </h2>
              <div className="space-y-4">
                <div>
                  <p className="font-medium mb-2">Dane z umowy wynajmu krótkoterminowego:</p>
                  <p>
                    Przetwarzane przez okres, w którym mogą ujawnić się roszczenia związane z tą umową,
                    czyli przez <strong>6+1 lat od końca roku, w którym wygasła umowa</strong>.
                  </p>
                </div>
                <div>
                  <p className="font-medium mb-2">Dane dla celów marketingu bezpośredniego:</p>
                  <p>
                    Przetwarzane do czasu, aż Pani/Pan zgłosi sprzeciw względem ich przetwarzania
                    w tym celu lub ustalimy, że się zdezaktualizowały.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4 text-gray-800">
                VI. Prawa osoby, której dane dotyczą
              </h2>
              <p className="mb-3">
                Zgodnie z RODO (Rozporządzenie Ogólne o Ochronie Danych), przysługuje Pani/Panu:
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Prawo dostępu do swoich danych oraz otrzymania ich kopii</li>
                <li>Prawo do sprostowania (poprawiania) i uzupełnienia swoich danych</li>
                <li>Prawo do usunięcia danych</li>
                <li>Prawo do ograniczenia przetwarzania danych</li>
                <li>Prawo do przenoszenia danych</li>
                <li>Prawo do wniesienia sprzeciwu wobec przetwarzania danych</li>
                <li>Prawo do cofnięcia zgody w każdym czasie</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4 text-gray-800">
                VII. Wykonywanie praw i skargi
              </h2>
              <div className="space-y-4">
                <div>
                  <p className="mb-2">
                    W celu wykonania swoich praw proszę skierować żądanie na dane teleadresowe
                    wskazane w punkcie I niniejszej informacji.
                  </p>
                </div>
                <div className="bg-blue-50 p-4 rounded-md border border-blue-200">
                  <p className="font-medium mb-2">Prawo do wniesienia skargi:</p>
                  <p>
                    Jeżeli uzna Pani/Pan, że Pani/Pana dane osobowe są przetwarzane niezgodnie
                    z wymogami prawa, ma Pani/Pan prawo wnieść skargę do organu nadzorczego
                    zajmującego się ochroną danych osobowych:
                  </p>
                  <div className="mt-2 p-3 bg-white rounded border">
                    <p>
                      <strong>Prezes Urzędu Ochrony Danych Osobowych</strong>
                      <br />
                      ul. Stawki 2
                      <br />
                      00-193 Warszawa
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4 text-gray-800">
                VIII. Przekazywanie danych poza UE
              </h2>
              <div className="bg-green-50 p-4 rounded-md border border-green-200">
                <p>
                  <strong>Nie przekazujemy</strong> Pani/Pana danych do państwa trzeciego
                  oraz organizacji międzynarodowej.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4 text-gray-800">
                Kontakt w sprawach ochrony danych
              </h2>
              <div className="bg-gray-50 p-4 rounded-md">
                <p>
                  We wszystkich sprawach dotyczących ochrony danych osobowych
                  prosimy o kontakt:
                </p>
                <div className="mt-3 space-y-2">
                  <p>
                    <span className="font-medium">Telefon:</span> +48 608 025 978
                  </p>
                  <p>
                    <span className="font-medium">E-mail:</span> kontakt@kolorowedomki.com
                  </p>
                  <p>
                    <span className="font-medium">Adres:</span> ul. Rydzowa 1, 84-104 Jastrzębia Góra
                  </p>
                </div>
              </div>
            </section>

            <div className="mt-8 pt-6 border-t">
              <p className="text-sm text-gray-500">
                Dokument przygotowany z należytą starannością. W przypadku pytań
                dotyczących ochrony danych osobowych zachęcamy do kontaktu.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;